import { subDays } from 'date-fns';

export const getEditDeadline = (booking: { pickUpDate: Date }) => subDays(booking.pickUpDate, 2);
